import { withInviterLoading } from 'containers/Join/SubLandingPage';
import DuoSubLandingPage from 'components/SubLandingPage/Duo';

export default withInviterLoading(DuoSubLandingPage);
